import React from 'react';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { Source } from '../../../queries/ats/titles/types/sources';
import { DetailsCallToAction } from '../details-call-to-action/details-call-to-action';
import { DetailsDynamicButtonRow } from '../details-dynamic-button-row/details-dynamic-button-row';
import { DetailsErrorBoundary } from '../details-error/details-error';
import { FocusedAsset } from '../use-focused-asset';
import css from './details-buttons.module.scss';

interface DetailsButtonsProps {
  asset: Asset;
  focusedAsset: FocusedAsset;
  source: Source;
}

export function DetailsButtons({ asset, focusedAsset, source }: DetailsButtonsProps) {
  return (
    <div className={css.buttons}>
      <DetailsErrorBoundary label="cta">
        <DetailsCallToAction asset={asset} focusedAsset={focusedAsset} source={source} />
      </DetailsErrorBoundary>
      <DetailsDynamicButtonRow asset={asset} focusedAsset={focusedAsset} source={source} />
    </div>
  );
}

function DetailsButtonsSkeleton() {
  return (
    <div className={css.buttons}>
      <DetailsCallToAction.Skeleton />
    </div>
  );
}

DetailsButtons.Skeleton = DetailsButtonsSkeleton;
